import tw, { styled } from "twin.macro";

export const Step = styled.li(({ active, disabled }) => [
  tw`relative  py-[0.875rem] cursor-pointer whitespace-nowrap  min-w-max text-center `,
  active && tw`bg-blue-500 px-7 text-white rounded-full`,
  !active && disabled && tw`opacity-30 pointer-events-none`,
]);
